import script from "./FormTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./FormTemplate.vue?vue&type=script&setup=true&lang=js"

import "./FormTemplate.vue?vue&type=style&index=0&id=61ac0298&lang=scss&scoped=true"
import "./FormTemplate.vue?vue&type=style&index=1&id=61ac0298&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ac0298"]])

export default __exports__